<div [formGroup]="gs.gastroForm">
  <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
    <div class="w50" style="height: 50px">
      <section class="m-box fulltext">
        <h2>Medical History</h2>
        <button class="t-btn-smart" *ngIf="!es.isClosed && ls.premissions?.Questionnaires" style="margin-bottom: 0.5em" [disabled]="aiSummaryLoading" (click)="getAiSummary()">
          {{ 'GUI.General.Buttons.Populate Smart History' | translate }}
          <span *ngIf="aiSummaryLoading" class="t-btn-smart-spinner"></span>
        </button>
        <textarea formControlName="MedicalHistory" class="scroller scroller-intro fulltext"
          style="min-height: 10em"></textarea>
        <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="
            atS.showAuto(
              gs.gastroForm?.get('MedicalHistory'),
              'Medical History',
              700
            )
          ">
          Auto Text
        </button>
      </section>
    </div>
    <div class="w50 summary-anamnesis" style="display: flex">
      <div class="summary-anamnesis"></div>
      <div class="w100 summary-recommendations" style="height: 100%; padding: 0">
        <section class="m-box fulltext" style="height: 100%">
          <h2>Purpose of Exam</h2>
          <textarea formControlName="ReasonExamination" class="scroller scroller-intro fulltext"
            style="min-height: 10em"></textarea>
          <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="
              atS.showAuto(
                gs.gastroForm?.get('ReasonExamination'),
                'Reason Examination',
                701
              )
            ">
            Auto Text
          </button>
        </section>
      </div>
    </div>
  </div>

  <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
    <!-- ======= Probe Type (Start) ======= -->
    <div class="w50">
      <section class="m-box" (dblclick)="gs.gastroForm.get('ProbeType').setValue(-1)">
        <h2>Probe Type</h2>
        <div class="picker-row">
          <div class="picker-add">
            <input
              class="t-field"
              placeholder="Add probe type"
              [(ngModel)]="extraProbeType"
              [ngModelOptions]="{standalone: true}"
              [disabled]="loadingProbeTypes || es.isClosed"
            />
            <button class="blue-btn picker-add-btn" [disabled]="loadingProbeTypes || es.isClosed" (click)="addProbeType()">+</button>
          </div>
          @if (loadingProbeTypes) {
            <div class="picker-select-skeleton"></div>
          } @else {
            <mat-form-field class="picker-select">
              <mat-label>Probe Type</mat-label>
              <mat-select [formControl]="gs.gastroForm.get('ProbeType')">
                <mat-select-trigger>{{gs.gastroForm.get('ProbeType').value}}</mat-select-trigger>
                @for (probe of probeTypeDropdownList; track probe) {
                  <mat-option [value]="probe">
                    <span class="picker-option">
                      <span>{{probe}}</span>
                      <button
                        mat-icon-button
                        class="picker-option-remove"
                        aria-label="Remove probe type"
                        (click)="$event.stopPropagation(); deleteProbeType(probe)"
                      >
                        ✕
                      </button>
                    </span>
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
      </section>
    </div>
    <!-- ======= Probe Type (End) ======= -->

    <!-- ======= Referring Doctor (Start) ======= -->
    <div class="w50">
      <section class="m-box" (dblclick)="gs.gastroForm.get('ReffDoc').setValue('')">
        <h2>Referring Doctor</h2>
        <div class="picker-row">
          <div class="picker-add">
            <input
              class="t-field"
              placeholder="Add referring doctor"
              [(ngModel)]="newRefDoc"
              [ngModelOptions]="{standalone: true}"
              [disabled]="loadingRefDocs || es.isClosed"
            />
            <button class="blue-btn picker-add-btn" [disabled]="loadingRefDocs || es.isClosed" (click)="addRefDoc()">+</button>
          </div>
          @if (loadingRefDocs) {
            <div class="picker-select-skeleton"></div>
          } @else {
            <mat-form-field class="picker-select">
              <mat-label>Referring Doctor</mat-label>
              <mat-select [formControl]="gs.gastroForm.get('ReffDoc')">
                <mat-select-trigger>{{gs.gastroForm.get('ReffDoc').value}}</mat-select-trigger>
                @for (doc of refDocList; track doc) {
                  <mat-option [value]="doc">
                    <span class="picker-option">
                      <span>{{doc}}</span>
                      <button
                        mat-icon-button
                        class="picker-option-remove"
                        aria-label="Remove referring doctor"
                        (click)="$event.stopPropagation(); deleteRefDoc(doc)"
                      >
                        ✕
                      </button>
                    </span>
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
      </section>
    </div>
    <!-- ======= Referring Doctor (End) ======= -->
  </div>

  <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
    <!-- Procedure Results Section -->
    <div class="w50">
      <section class="m-box" style="height: 100%;">
        <h2>Procedure Results</h2>
        <div class="l-flex-c l-flex-w indicative-fieldset h100">
          <label class="t-label-top">
            <input type="radio" formControlName="ProcedureResult" value="No Clinical Findings" class="custom-check -sq" />
            <i class="customInput-display -sq"></i>
            <span>No Clinical Findings</span>
          </label>
          <label class="t-label-top">
            <input type="radio" formControlName="ProcedureResult" value="Clinical Findings" class="custom-check -sq" />
            <i class="customInput-display -sq"></i>
            <span>Clinical Findings</span>
          </label>
          <label class="t-label-top">
            <input type="radio" formControlName="ProcedureResult" value="Urgent Clinical Findings" class="custom-check -sq" />
            <i class="customInput-display -sq"></i>
            <span>Urgent Clinical Findings</span>
          </label>
        </div>
      </section>
    </div>
    <div class="w50">
      <section class="m-box" (dblclick)="gs.gastroForm.get('ImagingQuality').setValue(-1)">
        <h2>
          Imaging Quality
        </h2>

        <div class="l-flex-c l-flex-w indicative-fieldset h100" style="justify-content: space-evenly">
          <label class="t-label-top">
            <input type="radio" formControlName="ImagingQuality" value="Poor" class="custom-check -sq" />
            <i class="customInput-display -sq"></i>
            <span>
              Poor
            </span>
          </label>

          <label class="t-label-top">
            <input type="radio" formControlName="ImagingQuality" value="Fair" class="custom-check -sq" />
            <i class="customInput-display -sq"></i>
            <span>
              Fair
            </span>
          </label>

          <label class="t-label-top">
            <input type="radio" formControlName="ImagingQuality" value="Good" class="custom-check -sq" />
            <i class="customInput-display -sq"></i>
            <span>
              Good
            </span>
          </label>
        </div>
      </section>
    </div>
  </div>
 <app-gastro-summary [hideSignature]="true" [hideRefDocAndResults]="true"></app-gastro-summary>
  <app-exam-diagnoses></app-exam-diagnoses>

  <div class="w100 summary">
    <section class="m-box">
      <h2>Summary of Exam</h2>
      <angular-editor formControlName="Summary" [config]="editorConfig" style="width: 100%"></angular-editor>
      <button class="t-btn-edit" *ngIf="! es.isClosed" (click)="atS.showAuto(gs.gastroForm.get('Summary'),'Summary',712, true, true)">Auto Text</button>
    </section>
  </div>

  <!-- =============== Exam Signature (Start) =============== -->
  <app-gastro-summary [signOnly]="true"></app-gastro-summary>
  <!-- =============== Exam Signature (End) =============== -->
</div>
